export default __webpack_public_path__ + "static/media/2.56478818.png";